<template>
  <v-card
    flat
    tile
    hover
    class='pa-1'
    :to="link"
  >
    <v-responsive
      height="200px"
    >
     <v-container fill-height fluid class='titleBackground pa-3'>
        <v-layout fill-height row wrap>
          <v-flex xs12 flexbox class='photo'>
            <v-btn fab color="white" class='cardIcon elevation-3'><v-icon large color="primary">{{icon}}</v-icon></v-btn>
          </v-flex>
          <v-flex class='groupName'>
            <h3 class=''>{{text}}</h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
    <v-card-actions class='pa-1 actions'>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.photo {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 90px;
  width: 100%;
  background-color: $amaze-yellow;
  text-align: center;
}
.cardIcon{
  position: relative;
  top: 48px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5) !important;
  border-radius: 50% !important;
  i {
    margin-left: 0;
  }
}
.titleBackground {
  h3 {
    color: #000;
    font-size: 24px;
    line-height: 120%;
    margin-top: 120px;
    text-align: center;
    width: 100%;
    // text-shadow: 0px 0px 5px #b89436;
  }
}
.actions{
  min-height: 43px;
}
</style>

<script>
export default {
  props: ["icon", "link", "text"],
  computed: {},
  mounted() {}
};
</script>
